'use client'

import React from 'react'

type Props = {
    force: number
    extent: number
    xAxisLabel: string
}

const WIDTH = 340
const HEIGHT = 200
const PAD_LEFT = 44
const PAD_RIGHT = 12
const PAD_TOP = 14
const PAD_BOTTOM = 28
const PLOT_W = WIDTH - PAD_LEFT - PAD_RIGHT
const PLOT_H = HEIGHT - PAD_TOP - PAD_BOTTOM

export default function ForceAreaChart({ force, extent, xAxisLabel }: Props) {
    const f = Math.abs(force) || 0.0001
    const e = Math.abs(extent) || 0.0001

    const xToSvg = (x: number) => PAD_LEFT + (x / e) * PLOT_W
    const yToSvg = (y: number) => PAD_TOP + PLOT_H - (y / f) * PLOT_H

    const rectX = xToSvg(0)
    const rectY = yToSvg(f)
    const rectW = xToSvg(e) - xToSvg(0)
    const rectH = yToSvg(0) - yToSvg(f)

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            <line x1={PAD_LEFT} y1={PAD_TOP} x2={PAD_LEFT} y2={HEIGHT - PAD_BOTTOM} stroke="#9ca3af" strokeWidth={1} />
            <line x1={PAD_LEFT} y1={HEIGHT - PAD_BOTTOM} x2={WIDTH - PAD_RIGHT} y2={HEIGHT - PAD_BOTTOM} stroke="#9ca3af" strokeWidth={1} />
            <text x={PAD_LEFT} y={HEIGHT - 8} fontSize={10} fill="#6b7280">{xAxisLabel}</text>
            <text x={4} y={PAD_TOP + 6} fontSize={10} fill="#6b7280">Force (N)</text>
            <rect x={rectX} y={rectY} width={rectW} height={rectH} fill="#2563eb" opacity={0.2} stroke="#2563eb" strokeWidth={2} />
        </svg>
    )
}
